import { apiClient } from './client';
import { WorkforceRequest } from '../types/workforce-request';

export const workforceRequestApi = {
  list: () => apiClient.get<{ data: WorkforceRequest[] }>('/api/workforce-requests'),
  get: (id: number) => apiClient.get<{ data: WorkforceRequest }>(`/api/workforce-requests/${id}`),
  create: (input: Record<string, unknown>) => apiClient.post<{ data: { id: number; requestReference: string } }>('/api/workforce-requests', input),
  submit: (id: number) => apiClient.post<{ data: { status: string } }>(`/api/workforce-requests/${id}/submit`),
  decide: (id: number, input: { decision: 'approved' | 'rejected'; comment?: string }) =>
    apiClient.post<{ data: { status: string } }>(`/api/workforce-requests/${id}/decide`, input),
  return: (id: number, comment: string) => apiClient.post<{ data: { status: string } }>(`/api/workforce-requests/${id}/return`, { comment }),
  resubmit: (id: number) => apiClient.post<{ data: { status: string } }>(`/api/workforce-requests/${id}/resubmit`),
};
